import React from 'react';

import { purifyServerHtml } from '~library/purifyHtml';
import './RenderedHtmlStyle.css';

type RenderedHtmlProps = {
  html?: string;
};

function RenderedHtml({ html }: RenderedHtmlProps) {
  if (!html) return null;
  return <div id="html-from-server" dangerouslySetInnerHTML={{ __html: purifyServerHtml(html) }} />;
}

export default RenderedHtml;
